// alterado - revisado

import React, { useState } from 'react'

import clsx from 'clsx'

import { 
    IsSmDownScreen,
} from '../Service/GlobalService'

import {
    Button,
    StepButton,
    IconButton,
    Step,
    Stepper,
    Icon,
    Typography,
} from '@material-ui/core'

import LABEL from '../../business-const/Label/Label'

import {
    formataValor
} from '../Formata/Formata'

import {
    GridContainer,
    GridContainerS3,
    GridItem3sm6xs6,
    GridItem12,
} from '../Grid/Grid'

import {
    CardGrid,
} from '../Card/Card'

const classNameButton = "mt-2 mb-2 ml-1 mr-1"
const variantButton = "contained"
const sizeIconButton = "medium"
const classNameIconButton = "p-3"
const orientationStepper = "horizontal" 
const classNameStepper = "overflow-auto mt-2 mb-2 justify-center border-radius-padrao"
const classNameStepperPadrao = classNameStepper + " bg-stepperPadrao"
const classNameStepperCardValor = classNameStepper + " bg-stepperCardValor"
const fontSizeIcon = "large"
const classNameDivTitleValuesStepsValor = "ml-1"
const classNameTitle = "m-0 text-16 text-muted"
const classNameValuesStepsTitle = "mt-2 text-10 text-muted font-light"
const classNameValuesStepsValor = "mt-1 text-18"
const classNameValuesStepsTitle2 = "mt-1 text-10 text-muted font-light"
const classNameValuesStepsValor2 = "mt-1 text-12 font-medium"
const classNameValuesStepsValorSubTotalTitle = "mt-4 text-12 text-muted font-light"
const classNameValuesStepsValorSubTotalValor = "mt-1 text-13"
const classNameValuesStepsValor2SubTotalValor = "mt-1 text-10 font-medium"
const classNameCardGrid = "p-3 border-radius-padrao" //"flex"

export const StepperPadrao = ( { stepsType, stepsIcon, stepsSvgIcon, steps, stepsTitle2, stepsContent,
    valuesStep, valuesStepsTitle, valuesStepsValor, valuesStepsTitle2, valuesStepsValor2,
        valuesStepsValorSubTotal1, valuesStepsValor2SubTotal1, valuesStepsValorSubTotal2,
            valuesStepsValor2SubTotal2, naoPermiteConcluir  } ) => {

    const [activeStep, setActiveStep] = useState(valuesStep.activeStep)
    const [completed, setCompleted] = useState(valuesStep.completed)

    const setValuesActiveStep = (activeStep) => {
        valuesStep.activeStep = activeStep
        setActiveStep(activeStep)
    }
    
    const setValuesCompleted = (completed) => {
        valuesStep.completed = completed
        setCompleted(completed)
    }

    const getStepContent = (step) =>  {
        return stepsContent[step]
    }

    const totalSteps = () => {
        return steps.length
    }

    const completedSteps = () => {
        return Object.keys(completed).length
    }
    
    const isFirtStep = () => {
        return activeStep === 0
    }

    const isLastStep = () => {
        return activeStep === totalSteps() - 1
    }

    const handleNext = () => {
        const newActiveStep = 
            isLastStep()
                ? 0
                : activeStep + 1
        setValuesActiveStep(newActiveStep)
    }

    const handleBack = () => {
        const newActiveStep = 
            isFirtStep()
                ? totalSteps() - 1
                : activeStep - 1
        setValuesActiveStep(newActiveStep)
    }

    const handleStep = step => () => {
        setValuesActiveStep(step)
    }

    const handleComplete = () => {
        const newCompleted = completed
        newCompleted[activeStep] = true
        setValuesCompleted(newCompleted)
        handleNext()
    }

    const bgColorIcon = (index) => {
        return activeStep === index ? "bg-iconSelected" : completed[index] ? "bg-iconCompleted" : "bg-muted"
    }

    const textColorIcon = (index) => {
        return activeStep === index ? "text-iconSelected" : completed[index] ? "text-iconCompleted" : "text-muted"
    }

    const svgIconStepButton = ( index ) => {
        const SvgIconStepButton = stepsSvgIcon[index]

        return (
            <SvgIconStepButton
                className={textColorIcon(index)}
                fontSize={fontSizeIcon}
            />
        )
    }

    return (
        <div>
            {!naoPermiteConcluir
                ?
                    <div align="right">
                        {!completed[activeStep]
                            ?
                                <Button
                                    className={clsx(classNameButton, "bg-iconCompleted text-iconCompleted")}
                                    variant={variantButton}
                                    onClick={handleComplete}
                                >
                                    {completedSteps() === totalSteps() - 1
                                    ? LABEL.buttonConcluir
                                    : LABEL.buttonConcluirEtapa}
                                </Button>
                            :
                                ''
                        }
                        <Button 
                            className={classNameButton}
                            variant={variantButton}
                            color="secondary"
                            onClick={handleBack}
                        >
                            {LABEL.buttonVoltar}
                        </Button>
                        <Button
                            className={classNameButton}
                            variant={variantButton}
                            color="primary"
                            onClick={handleNext}
                        >
                            {LABEL.buttonProximo}
                        </Button>
                    
                    </div>
                : 
                    '' 
            }

            <GridContainer>
                <GridItem12>
                    {stepsType === "padrao" ?
                        <Stepper
                            nonLinear
                            activeStep={activeStep}
                            orientation={orientationStepper}
                            className={classNameStepperPadrao}
                        >
                            {steps.map((title, index) => (
                                <Step 
                                    key={index}
                                >
                                    <StepButton
                                        onClick={handleStep(index)}
                                        completed={completed[index]}
                                        icon={
                                            <IconButton
                                                size={sizeIconButton}
                                                className={clsx(classNameIconButton, bgColorIcon(index))}
                                            >
                                                {stepsIcon
                                                    ?
                                                        <Icon
                                                            className={textColorIcon(index)}
                                                            fontSize={fontSizeIcon}
                                                        >
                                                            {stepsIcon[index]}
                                                        </Icon>
                                                    :
                                                        svgIconStepButton(index)
                                                }
                                            </IconButton>
                                        }
                                    >
                                        <div>
                                            <Typography
                                                className={clsx(classNameTitle,
                                                    activeStep === index ? "text-selected" : completed[index] ? "text-completed" : "text-muted"
                                                )}
                                            >
                                                {title}
                                            </Typography>
                                        </div>
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>
                    :
                        IsSmDownScreen() ?
                            <GridContainerS3
                                className="mt-2 mb-1 justify-center"
                            >
                                {steps.map((title, index) => (
                                    <GridItem3sm6xs6
                                        key={index}
                                    >
                                        <StepButton
                                            onClick={handleStep(index)}
                                        >
                                            <CardGrid className={classNameCardGrid}>
                                                <div>
                                                    <IconButton
                                                        size={sizeIconButton}
                                                        className={clsx(classNameIconButton, bgColorIcon(index))}
                                                    >
                                                        {stepsIcon
                                                            ?
                                                                <Icon
                                                                    className={textColorIcon(index)}
                                                                    fontSize={fontSizeIcon}
                                                                >
                                                                    {stepsIcon[index]}
                                                                </Icon>
                                                            :
                                                                svgIconStepButton(index)
                                                        }
                                                    </IconButton>
                                                </div>
                                                <div className={classNameDivTitleValuesStepsValor}>
                                                    <p className={classNameTitle}>{title}</p>
                                                    {stepsTitle2
                                                        ?
                                                            <p className={classNameTitle}>{stepsTitle2[index]}</p>
                                                        :
                                                            ''
                                                    }
                                                    <h3 className={classNameValuesStepsTitle}>
                                                        {valuesStepsValor[index] && valuesStepsTitle
                                                            ?
                                                                valuesStepsTitle[index]
                                                            :
                                                                ''
                                                        }
                                                    </h3>
                                                    <h3 className={classNameValuesStepsValor}>
                                                        {valuesStepsValor[index]
                                                                ?
                                                                    formataValor(valuesStepsValor[index], 2)
                                                                :
                                                                    ''
                                                            }
                                                    </h3>
                                                    <h6 className={classNameValuesStepsTitle2}>
                                                        {(valuesStepsValor2[index] || (valuesStepsValor[index] && valuesStepsValor2[index] === 0)) && valuesStepsTitle2
                                                            ?
                                                                valuesStepsTitle2[index]
                                                            :
                                                                ''
                                                        }
                                                    </h6>
                                                    <h6 className={classNameValuesStepsValor2}>
                                                        {valuesStepsValor2[index] || (valuesStepsValor[index] && valuesStepsValor2[index] === 0)
                                                            ?
                                                                formataValor(valuesStepsValor2[index], 2)
                                                            :
                                                                ''
                                                        }
                                                    </h6>
                                                    {valuesStepsValorSubTotal1 &&
                                                        valuesStepsValorSubTotal1[index].valor > 0
                                                        ?
                                                            <>
                                                                <br/>
                                                                <h5
                                                                    className={classNameValuesStepsValorSubTotalTitle}
                                                                >
                                                                    {valuesStepsValorSubTotal1[index].title}
                                                                </h5>

                                                                <h5
                                                                    className={classNameValuesStepsValorSubTotalValor}
                                                                >
                                                                    {formataValor(valuesStepsValorSubTotal1[index].valor, 2)}
                                                                </h5>

                                                                {valuesStepsValor2SubTotal1
                                                                    ?
                                                                        <h6
                                                                            className={classNameValuesStepsValor2SubTotalValor}
                                                                        >
                                                                            {formataValor(valuesStepsValor2SubTotal1[index].valor, 2)}
                                                                        </h6>
                                                                    :
                                                                        ''
                                                                }
                                                            </>
                                                                :
                                                                    ''
                                                    }
                                                    {valuesStepsValorSubTotal2 &&
                                                        valuesStepsValorSubTotal2[index].valor > 0
                                                        ?
                                                            <>
                                                                <h5
                                                                    className={classNameValuesStepsValorSubTotalTitle}
                                                                >
                                                                    {valuesStepsValorSubTotal2[index].title}
                                                                </h5>

                                                                <h5
                                                                    className={classNameValuesStepsValorSubTotalValor}
                                                                >
                                                                    {formataValor(valuesStepsValorSubTotal2[index].valor, 2)}
                                                                </h5>

                                                                {valuesStepsValor2SubTotal2
                                                                    ?
                                                                        <h6
                                                                            className={classNameValuesStepsValor2SubTotalValor}
                                                                        >
                                                                            {formataValor(valuesStepsValor2SubTotal2[index].valor, 2)}
                                                                        </h6>
                                                                    :
                                                                        ''
                                                                }
                                                            </>
                                                                :
                                                                    ''
                                                    }
                                                </div>
                                            </CardGrid>
                                        </StepButton>
                                    </GridItem3sm6xs6>
                                ))}
                            </GridContainerS3>
                        :
                            <Stepper
                                nonLinear
                                activeStep={activeStep}
                                orientation={orientationStepper}
                                className={classNameStepperCardValor}
                            >
                                {steps.map((title, index) => (
                                    <Step
                                        key={index}
                                    >
                                        <StepButton
                                            onClick={handleStep(index)}
                                            completed={completed[index]}
                                            icon={
                                                <CardGrid className={classNameCardGrid}>
                                                    <div>
                                                        <IconButton
                                                            size={sizeIconButton}
                                                            className={clsx(classNameIconButton, bgColorIcon(index))}
                                                        >
                                                            {stepsIcon
                                                                ?
                                                                    <Icon
                                                                        className={textColorIcon(index)}
                                                                        fontSize={fontSizeIcon}
                                                                    >
                                                                        {stepsIcon[index]}
                                                                    </Icon>
                                                                :
                                                                    svgIconStepButton(index)
                                                            }
                                                        </IconButton>
                                                    </div>
                                                    <div className={classNameDivTitleValuesStepsValor}>
                                                        <p className={classNameTitle}>{title}</p>
                                                        {stepsTitle2
                                                            ?
                                                                <p className={classNameTitle}>{stepsTitle2[index]}</p>
                                                            :
                                                                ''
                                                        }
                                                        <h3 className={classNameValuesStepsTitle}>
                                                            {valuesStepsValor[index] && valuesStepsTitle
                                                                ?
                                                                    valuesStepsTitle[index]
                                                                :
                                                                    ''
                                                            }
                                                        </h3>
                                                        <h3 className={classNameValuesStepsValor}>
                                                            {valuesStepsValor[index]
                                                                ?
                                                                    formataValor(valuesStepsValor[index], 2)
                                                                :
                                                                    ''
                                                            }
                                                        </h3>
                                                        <h6 className={classNameValuesStepsTitle2}>
                                                            {(valuesStepsValor2[index] || (valuesStepsValor[index] && valuesStepsValor2[index] === 0)) && valuesStepsTitle2
                                                                ?
                                                                    valuesStepsTitle2[index]
                                                                :
                                                                    ''
                                                            }
                                                        </h6>
                                                        <h6 className={classNameValuesStepsValor2}>
                                                            {valuesStepsValor2[index] || (valuesStepsValor[index] && valuesStepsValor2[index] === 0)
                                                                ?
                                                                    formataValor(valuesStepsValor2[index], 2)
                                                                :
                                                                    ''
                                                            }
                                                        </h6>
                                                        {valuesStepsValorSubTotal1 &&
                                                            valuesStepsValorSubTotal1[index].valor > 0
                                                            ?
                                                                <>
                                                                    <br/>
                                                                    <h5
                                                                        className={classNameValuesStepsValorSubTotalTitle}
                                                                    >
                                                                        {valuesStepsValorSubTotal1[index].title}
                                                                    </h5>

                                                                    <h5
                                                                        className={classNameValuesStepsValorSubTotalValor}
                                                                    >
                                                                        {formataValor(valuesStepsValorSubTotal1[index].valor, 2)}
                                                                    </h5>
                                                                    
                                                                    {valuesStepsValor2SubTotal1
                                                                        ?
                                                                            <h6
                                                                                className={classNameValuesStepsValor2SubTotalValor}
                                                                            >
                                                                                {formataValor(valuesStepsValor2SubTotal1[index].valor, 2)}
                                                                            </h6>
                                                                        :
                                                                            ''
                                                                    }
                                                                </>
                                                                    :
                                                                        ''
                                                        }
                                                        {valuesStepsValorSubTotal2 &&
                                                            valuesStepsValorSubTotal2[index].valor > 0
                                                            ?
                                                                <>
                                                                    <h5
                                                                        className={classNameValuesStepsValorSubTotalTitle}
                                                                    >
                                                                        {valuesStepsValorSubTotal2[index].title}
                                                                    </h5>

                                                                    <h5
                                                                        className={classNameValuesStepsValorSubTotalValor}
                                                                    >
                                                                        {formataValor(valuesStepsValorSubTotal2[index].valor, 2)}
                                                                    </h5>
                                                                    
                                                                    {valuesStepsValor2SubTotal2
                                                                        ?
                                                                            <h6
                                                                                className={classNameValuesStepsValor2SubTotalValor}
                                                                            >
                                                                                {formataValor(valuesStepsValor2SubTotal2[index].valor, 2)}
                                                                            </h6>
                                                                        :
                                                                            ''
                                                                    }
                                                                </>
                                                                    :
                                                                        ''
                                                        }
                                                    </div>
                                                </CardGrid>
                                            }
                                        />
                                    </Step>
                                    
                                ))}
                            </Stepper>
                    }
                </GridItem12>
            </GridContainer>

            <div>
                {getStepContent (activeStep)}
            </div>
        </div>
    )
}